import { FormControl, TextField, Tooltip } from "@mui/material";
import { useFormikContext } from "formik";
import { AddClientFormValues } from "../../types";

function ReadOnlyPricingPlan() {
  const { values } = useFormikContext<AddClientFormValues>();

  return (
    <Tooltip title="It is not possible to select a pricing plan at this point, because the client's user must be linked to Stripe. Please link the client's user to Stripe once created, then edit the client to select a pricing plan. Until then, defaulting to the “free” plan.">
      <FormControl
        fullWidth
        sx={{
          marginBottom: "2%",
          marginTop: "2%",
          width: "100%",
          float: "right",
        }}
        variant="standard"
      >
        <TextField
          sx={{ width: "100%", float: "right" }}
          id="client-pricing-plan"
          label="Pricing Plan"
          variant="standard"
          autoComplete="off"
          fullWidth
          disabled
          value={values["client-pricing-plan"]}
        />
      </FormControl>
    </Tooltip>
  );
}

export default ReadOnlyPricingPlan;
